export interface ZuperUserRole {
  role_uid: string;
  role_name: string;
  role_key: string;
}

export interface ZuperUser {
  user_uid: string;
  first_name: string;
  last_name: string;
  email: string;
  profile_picture: string | null;
  designation: string | null;
  emp_code: string | null;
  home_phone_number: string | null;
  work_phone_number: string | null;
  mobile_phone_number: string | null;
  hourly_labor_charge: number | null;
  is_active: boolean;
  is_deleted: boolean;
  created_at: string;
  updated_at: string;
  last_login_at: string | null;
  role: ZuperUserRole;
}

export interface ZuperUsersResponse {
  type: 'success' | 'error';
  data: ZuperUser[];
  total_records: number;
  total_pages: number;
  current_page: number;
}

export interface ZuperUserResponse {
  type: 'success' | 'error';
  data: ZuperUser;
}

// Authentication types
export interface LoginCredentials {
  email: string;
  password: string;
}

export interface LoginRequest {
  company_login_name: string;
  email: string;
  password: string;
}

export interface LoginResponse {
  type: 'success' | 'error';
  message?: string;
  data?: {
    auth_token: string;
    user: ZuperUser;
  };
}

export interface AuthState {
  auth_token: string;
  user: ZuperUser;
}

// Constants
export const ZUPER_COMPANY_NAME = 'zuper-ericsson';
export const ZUPER_TEAM_UID = '6a58ee47-a540-4a2d-ac58-9f6cfbd7e52b';

// Keep ZuperSettings for backward compatibility
export interface ZuperSettings {
  team_uid: string;
  user_uid: string;
  auth_token: string;
}

export const ZUPER_STORAGE_KEYS = {
  AUTH: 'zuper_auth',
  // Legacy key for migration
  SETTINGS: 'zuper_settings',
} as const;
